import { FC, lazy } from 'react';

const MigrationEmailSentPageDefaultView = lazy(
  () => import('./default-view/MigrationEmailSentPageDefaultView'),
);

export const MigrationEmailSentPage: FC = () => <MigrationEmailSentPageDefaultView />;
